import './styles/app.scss'

// Utility
import browserClasses from './javascript/utils/bowser'
import lazyLoad from './javascript/utils/lazy'
import smoothscroll from './javascript/utils/smoothscroll'
import stringReplace from './javascript/utils/stringreplace'

// Pages
import Landing from './javascript/pages/p-landing'
import Insights from './javascript/pages/p-insights'

// Components
import Customers from './javascript/components/c-customers'
import CustomersNoImage from './javascript/components/c-customersNoImage'
import Menu from './javascript/components/c-menu'
import Trainings from './javascript/components/c-trainings'
import TrainingIntro from './javascript/components/c-trainingIntro'
import TrainingEvents from './javascript/components/c-trainingEvents'
import Benefits from './javascript/components/c-benefits'
import Programme from './javascript/components/c-programme'
import Tooltip from './javascript/components/c-tooltip'
import EventRegistration from './javascript/components/c-eventRegistration'
import Footer from './javascript/components/c-footer'
import FormSubmission from './javascript/components/c-formSubmission'
import TrainingsHero from './javascript/components/c-heroTrainings'
import TrainingsFilter from './javascript/components/c-trainingsFilter'

import objectFitImages from 'object-fit-images'

const app = {
  init: function () {
    // Utility
    browserClasses()
    lazyLoad()
    smoothscroll()
    stringReplace()

    // Pages
    Landing()
    Insights()

    // Components
    Menu()
    Customers()
    CustomersNoImage()
    Trainings()
    Benefits()
    Programme()
    Tooltip()
    //EventRegistration()
    FormSubmission()
    Footer()
    TrainingEvents()
    TrainingIntro()
    objectFitImages()
    TrainingsHero()
    TrainingsFilter()
  }
}

app.init()
